const SCRIPT_TEMPLATES = {
  empty: {
    name: 'Document vide',
    icon: '📄',
    description: 'Commencer de zéro',
    elements: [
      { type: 'scene', content: 'INT. LIEU - JOUR' },
      { type: 'action', content: '' }
    ]
  },
  threeActs: {
    name: 'Structure 3 Actes',
    icon: '🎭',
    description: 'Setup, Confrontation, Résolution',
    elements: [
      { type: 'scene', content: '=== ACTE 1 - SETUP ===' },
      { type: 'action', content: '[Le monde ordinaire du protagoniste. Présentation des personnages et de l\'univers.]' },
      { type: 'scene', content: 'INT. LIEU DE VIE DU HÉROS - JOUR' },
      { type: 'action', content: '[Introduction du protagoniste dans son quotidien]' },
      { type: 'scene', content: 'INT./EXT. LIEU - JOUR/NUIT' },
      { type: 'action', content: '[L\'incident déclencheur qui bouleverse l\'équilibre]' },
      { type: 'scene', content: '=== ACTE 2 - CONFRONTATION ===' },
      { type: 'action', content: '[Le protagoniste fait face aux obstacles. Montée des enjeux.]' },
      { type: 'scene', content: 'INT./EXT. NOUVEAU MONDE - JOUR' },
      { type: 'action', content: '[Le héros entre dans un nouveau monde / nouvelle situation]' },
      { type: 'scene', content: 'INT./EXT. LIEU - JOUR/NUIT' },
      { type: 'action', content: '[Tests, alliés, ennemis. Le héros apprend les règles.]' },
      { type: 'scene', content: 'INT./EXT. LIEU - JOUR/NUIT' },
      { type: 'action', content: '[MIDPOINT - Fausse victoire ou fausse défaite]' },
      { type: 'scene', content: 'INT./EXT. LIEU - JOUR/NUIT' },
      { type: 'action', content: '[Les enjeux augmentent. Le héros perd tout espoir.]' },
      { type: 'scene', content: '=== ACTE 3 - RÉSOLUTION ===' },
      { type: 'action', content: '[Le climax et la résolution finale.]' },
      { type: 'scene', content: 'INT./EXT. LIEU DU CLIMAX - JOUR/NUIT' },
      { type: 'action', content: '[Confrontation finale. Le héros utilise tout ce qu\'il a appris.]' },
      { type: 'scene', content: 'INT./EXT. LIEU - JOUR' },
      { type: 'action', content: '[Résolution. Le nouveau monde ordinaire du héros.]' }
    ]
  },
  fiveActs: {
    name: 'Structure 5 Actes',
    icon: '🎪',
    description: 'Shakespeare / Tragédie classique',
    elements: [
      { type: 'scene', content: '=== ACTE 1 - EXPOSITION ===' },
      { type: 'action', content: '[Présentation du monde, des personnages et du conflit latent]' },
      { type: 'scene', content: 'INT./EXT. LIEU - JOUR' },
      { type: 'action', content: '' },
      { type: 'scene', content: '=== ACTE 2 - MONTÉE DE L\'ACTION ===' },
      { type: 'action', content: '[L\'événement déclencheur. Les complications commencent.]' },
      { type: 'scene', content: 'INT./EXT. LIEU - JOUR/NUIT' },
      { type: 'action', content: '' },
      { type: 'scene', content: '=== ACTE 3 - CLIMAX ===' },
      { type: 'action', content: '[Le point de non-retour. La crise atteint son paroxysme.]' },
      { type: 'scene', content: 'INT./EXT. LIEU - JOUR/NUIT' },
      { type: 'action', content: '' },
      { type: 'scene', content: '=== ACTE 4 - CHUTE ===' },
      { type: 'action', content: '[Les conséquences du climax. Tout s\'effondre ou se reconstruit.]' },
      { type: 'scene', content: 'INT./EXT. LIEU - JOUR/NUIT' },
      { type: 'action', content: '' },
      { type: 'scene', content: '=== ACTE 5 - DÉNOUEMENT ===' },
      { type: 'action', content: '[La résolution finale. Catharsis.]' },
      { type: 'scene', content: 'INT./EXT. LIEU - JOUR' },
      { type: 'action', content: '' }
    ]
  },
  herosJourney: {
    name: 'Le Voyage du Héros',
    icon: '🗡️',
    description: 'Joseph Campbell - 12 étapes',
    elements: [
      { type: 'scene', content: '=== 1. LE MONDE ORDINAIRE ===' },
      { type: 'action', content: '[Le héros dans son environnement quotidien avant l\'aventure]' },
      { type: 'scene', content: 'INT. MAISON DU HÉROS - JOUR' },
      { type: 'action', content: '' },
      { type: 'scene', content: '=== 2. L\'APPEL DE L\'AVENTURE ===' },
      { type: 'action', content: '[Un problème ou un défi se présente au héros]' },
      { type: 'scene', content: 'INT./EXT. LIEU - JOUR/NUIT' },
      { type: 'action', content: '' },
      { type: 'scene', content: '=== 3. LE REFUS DE L\'APPEL ===' },
      { type: 'action', content: '[Le héros hésite, a peur de l\'inconnu]' },
      { type: 'scene', content: 'INT. LIEU - JOUR/NUIT' },
      { type: 'action', content: '' },
      { type: 'scene', content: '=== 4. LA RENCONTRE AVEC LE MENTOR ===' },
      { type: 'action', content: '[Un guide apparaît pour aider le héros]' },
      { type: 'scene', content: 'INT./EXT. LIEU - JOUR' },
      { type: 'action', content: '' },
      { type: 'scene', content: '=== 5. LE PASSAGE DU SEUIL ===' },
      { type: 'action', content: '[Le héros s\'engage dans l\'aventure, quitte le monde ordinaire]' },
      { type: 'scene', content: 'EXT. FRONTIÈRE/SEUIL - JOUR' },
      { type: 'action', content: '' },
      { type: 'scene', content: '=== 6. ÉPREUVES, ALLIÉS, ENNEMIS ===' },
      { type: 'action', content: '[Le héros fait face à des tests, rencontre des alliés et des ennemis]' },
      { type: 'scene', content: 'INT./EXT. MONDE SPÉCIAL - JOUR/NUIT' },
      { type: 'action', content: '' },
      { type: 'scene', content: '=== 7. L\'APPROCHE DE LA CAVERNE ===' },
      { type: 'action', content: '[Préparation pour le défi majeur]' },
      { type: 'scene', content: 'INT./EXT. APPROCHE DU DANGER - NUIT' },
      { type: 'action', content: '' },
      { type: 'scene', content: '=== 8. L\'ÉPREUVE SUPRÊME ===' },
      { type: 'action', content: '[Le héros affronte sa plus grande peur, mort symbolique]' },
      { type: 'scene', content: 'INT. CAVERNE/LIEU DU DANGER - NUIT' },
      { type: 'action', content: '' },
      { type: 'scene', content: '=== 9. LA RÉCOMPENSE ===' },
      { type: 'action', content: '[Le héros s\'empare du trésor/élixir après l\'épreuve]' },
      { type: 'scene', content: 'INT./EXT. LIEU - JOUR' },
      { type: 'action', content: '' },
      { type: 'scene', content: '=== 10. LE CHEMIN DU RETOUR ===' },
      { type: 'action', content: '[Le héros doit rentrer avec ce qu\'il a gagné]' },
      { type: 'scene', content: 'EXT. CHEMIN DU RETOUR - JOUR' },
      { type: 'action', content: '' },
      { type: 'scene', content: '=== 11. LA RÉSURRECTION ===' },
      { type: 'action', content: '[Ultime épreuve, transformation finale du héros]' },
      { type: 'scene', content: 'INT./EXT. LIEU DU CLIMAX - JOUR' },
      { type: 'action', content: '' },
      { type: 'scene', content: '=== 12. LE RETOUR AVEC L\'ÉLIXIR ===' },
      { type: 'action', content: '[Le héros revient transformé avec le pouvoir de changer son monde]' },
      { type: 'scene', content: 'INT. MONDE ORDINAIRE - JOUR' },
      { type: 'action', content: '' }
    ]
  },
  saveTheCat: {
    name: 'Save the Cat',
    icon: '🐱',
    description: 'Blake Snyder - 15 beats',
    elements: [
      { type: 'scene', content: '=== 1. IMAGE D\'OUVERTURE (p.1) ===' },
      { type: 'action', content: '[L\'image qui donne le ton. Miroir de l\'image finale.]' },
      { type: 'scene', content: 'INT./EXT. LIEU - JOUR/NUIT' },
      { type: 'action', content: '' },
      { type: 'scene', content: '=== 2. THÈME ÉNONCÉ (p.5) ===' },
      { type: 'action', content: '[Quelqu\'un dit au héros ce que sera sa leçon de vie]' },
      { type: 'scene', content: 'INT./EXT. LIEU - JOUR' },
      { type: 'action', content: '' },
      { type: 'scene', content: '=== 3. SET-UP (p.1-10) ===' },
      { type: 'action', content: '[Le monde "avant". Tout ce qui doit être fixé. Les 6 choses qui doivent être améliorées.]' },
      { type: 'scene', content: 'INT./EXT. LIEU - JOUR' },
      { type: 'action', content: '' },
      { type: 'scene', content: '=== 4. CATALYSEUR (p.12) ===' },
      { type: 'action', content: '[L\'événement qui change tout. Télégramme, rencontre, découverte...]' },
      { type: 'scene', content: 'INT./EXT. LIEU - JOUR' },
      { type: 'action', content: '' },
      { type: 'scene', content: '=== 5. DÉBAT (p.12-25) ===' },
      { type: 'action', content: '[Le héros doute. Dernière chance de refuser l\'aventure.]' },
      { type: 'scene', content: 'INT./EXT. LIEU - JOUR/NUIT' },
      { type: 'action', content: '' },
      { type: 'scene', content: '=== 6. PASSAGE À L\'ACTE 2 (p.25) ===' },
      { type: 'action', content: '[Le héros choisit d\'agir. Il entre dans un monde inversé.]' },
      { type: 'scene', content: 'INT./EXT. NOUVEAU MONDE - JOUR' },
      { type: 'action', content: '' },
      { type: 'scene', content: '=== 7. HISTOIRE B (p.30) ===' },
      { type: 'action', content: '[L\'histoire d\'amour ou l\'histoire du thème. Nouveaux personnages.]' },
      { type: 'scene', content: 'INT./EXT. LIEU - JOUR' },
      { type: 'action', content: '' },
      { type: 'scene', content: '=== 8. FUN AND GAMES (p.30-55) ===' },
      { type: 'action', content: '[La promesse du concept. Ce pourquoi le public est venu.]' },
      { type: 'scene', content: 'INT./EXT. LIEU - JOUR/NUIT' },
      { type: 'action', content: '' },
      { type: 'scene', content: '=== 9. MIDPOINT (p.55) ===' },
      { type: 'action', content: '[Fausse victoire ou fausse défaite. Les enjeux montent. Horloge activée.]' },
      { type: 'scene', content: 'INT./EXT. LIEU - JOUR/NUIT' },
      { type: 'action', content: '' },
      { type: 'scene', content: '=== 10. LES MÉCHANTS SE RAPPROCHENT (p.55-75) ===' },
      { type: 'action', content: '[Les forces antagonistes se regroupent. L\'équipe du héros se désagrège.]' },
      { type: 'scene', content: 'INT./EXT. LIEU - JOUR/NUIT' },
      { type: 'action', content: '' },
      { type: 'scene', content: '=== 11. TOUT EST PERDU (p.75) ===' },
      { type: 'action', content: '[L\'opposé du Midpoint. Mort du mentor. Tout semble fini.]' },
      { type: 'scene', content: 'INT./EXT. LIEU - NUIT' },
      { type: 'action', content: '' },
      { type: 'scene', content: '=== 12. LA NUIT NOIRE DE L\'ÂME (p.75-85) ===' },
      { type: 'action', content: '[Le héros est au plus bas. Moment de réflexion profonde.]' },
      { type: 'scene', content: 'INT. LIEU ISOLÉ - NUIT' },
      { type: 'action', content: '' },
      { type: 'scene', content: '=== 13. PASSAGE À L\'ACTE 3 (p.85) ===' },
      { type: 'action', content: '[Eureka! La solution vient de l\'histoire B et du thème.]' },
      { type: 'scene', content: 'INT./EXT. LIEU - AUBE' },
      { type: 'action', content: '' },
      { type: 'scene', content: '=== 14. FINALE (p.85-110) ===' },
      { type: 'action', content: '[Le héros applique sa leçon. Confrontation finale. Nouveau monde créé.]' },
      { type: 'scene', content: 'INT./EXT. LIEU DU CLIMAX - JOUR' },
      { type: 'action', content: '' },
      { type: 'scene', content: '=== 15. IMAGE FINALE (p.110) ===' },
      { type: 'action', content: '[L\'opposé de l\'image d\'ouverture. Preuve que le changement a eu lieu.]' },
      { type: 'scene', content: 'INT./EXT. LIEU - JOUR' },
      { type: 'action', content: '' }
    ]
  },
  sequence: {
    name: 'Approche Séquentielle',
    icon: '🎬',
    description: '8 séquences de 12-15 pages',
    elements: [
      { type: 'scene', content: '=== SÉQUENCE 1 - STATUS QUO & INCIDENT (p.1-12) ===' },
      { type: 'action', content: '[Le monde du protagoniste. L\'incident déclencheur arrive à la fin.]' },
      { type: 'scene', content: 'INT./EXT. LIEU - JOUR' },
      { type: 'action', content: '' },
      { type: 'scene', content: '=== SÉQUENCE 2 - PRÉDICAMENT (p.12-25) ===' },
      { type: 'action', content: '[Le héros réagit à l\'incident. Il formule son but.]' },
      { type: 'scene', content: 'INT./EXT. LIEU - JOUR' },
      { type: 'action', content: '' },
      { type: 'scene', content: '=== SÉQUENCE 3 - PREMIÈRE TENTATIVE (p.25-37) ===' },
      { type: 'action', content: '[Première vraie tentative pour résoudre le problème.]' },
      { type: 'scene', content: 'INT./EXT. LIEU - JOUR/NUIT' },
      { type: 'action', content: '' },
      { type: 'scene', content: '=== SÉQUENCE 4 - PLUS GRAND OBSTACLE (p.37-50) ===' },
      { type: 'action', content: '[Les enjeux augmentent. Échec de la première approche.]' },
      { type: 'scene', content: 'INT./EXT. LIEU - JOUR/NUIT' },
      { type: 'action', content: '' },
      { type: 'scene', content: '=== SÉQUENCE 5 - PREMIER CLIMAX (p.50-62) ===' },
      { type: 'action', content: '[Point central. Le héros semble réussir ou échouer spectaculairement.]' },
      { type: 'scene', content: 'INT./EXT. LIEU - JOUR/NUIT' },
      { type: 'action', content: '' },
      { type: 'scene', content: '=== SÉQUENCE 6 - NOUVELLES COMPLICATIONS (p.62-75) ===' },
      { type: 'action', content: '[Les conséquences du midpoint créent de nouveaux problèmes.]' },
      { type: 'scene', content: 'INT./EXT. LIEU - JOUR/NUIT' },
      { type: 'action', content: '' },
      { type: 'scene', content: '=== SÉQUENCE 7 - SECOND CLIMAX (p.75-87) ===' },
      { type: 'action', content: '[Tout est perdu. Le héros touche le fond.]' },
      { type: 'scene', content: 'INT./EXT. LIEU - NUIT' },
      { type: 'action', content: '' },
      { type: 'scene', content: '=== SÉQUENCE 8 - RÉSOLUTION (p.87-110) ===' },
      { type: 'action', content: '[Climax final et résolution. Le héros triomphe ou échoue définitivement.]' },
      { type: 'scene', content: 'INT./EXT. LIEU - JOUR' },
      { type: 'action', content: '' }
    ]
  }
};

export { SCRIPT_TEMPLATES };
